module.exports = __webpack_public_path__ + "static/img/2bg_15.53004cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_15.png
// module id = 674
// module chunks = 1